import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BoardResponseModel } from 'src/app/model/BoardResponseModel';
import { DashboardResponseModel } from 'src/app/model/DashboardResponseModel';
import { InvoiceDetailsResponseModel } from 'src/app/model/InvoiceDetailsResponseModel';
import { InvoiceTrackingResponseModel } from 'src/app/model/InvoiceTrackingResponseModel';
import { Page } from 'src/app/model/Page';
import { TenementExchangeModel } from 'src/app/model/TenementExchangeModel';
import { ApiUrls } from 'src/app/services/ApiUrls';
import { MasterService } from 'src/app/services/master.service';
import { InvoiceModal } from '../invoice-modal/invoice-modal';


@Component({
  selector: 'app-secure-invoice-tracking',
  templateUrl: './invoice-tracking-form.component.html',
  styleUrls: ['./invoice-tracking-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InvoiceTrackingFormComponent implements OnInit {
  
  page: Page<InvoiceDetailsResponseModel>;
  dataSource: MatTableDataSource<InvoiceDetailsResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;

  boardList: {[key:number]:string};

  public lotteryList: {[key:number]:string};

  public schemeList: {[key:number]:string};
  isSubmitDisabled: boolean = false;
  schemeCode: string
  stageValue: number;
  stageName: string;
  isLoadingAfterSave = false;

  boardKey: number;
  selectAllChecked: boolean = false;
  lotteryKey: number;
  data: InvoiceDetailsResponseModel;
  key: number;
  applicationId: number;
  stage_no: number;
  invoiceNo: string;
  tenementId: number;
  invoiceStatus: string;
  // selectedElement: InvoiceTrackingResponseModel | null = null;
  selectedElements: InvoiceDetailsResponseModel[] = [];

  // selectedElement: InvoiceTrackingResponseModel | null = null;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
 
  stageList: any[] = [
    { name: "1 - Verification of documents", value: "1" },
    { name: "2 - POL Issued", value: "2", },
    { name: "3 - Operate Waitlist & LOI", value: "3" },
    { name: "4 - Demand Issued", value: "4" },
    { name: "5 - Allotment Issued", value: "5" },
    { name: "6 - Possession & Keyhandover", value: "6" },
  ];
  displayedColumns: string[] = [
    "id",
    "schemeCode",
    "tenementDetails",
    "applicationNo",
    "name",
    "drawStatus",
    "currentStage",
    "action"
  ];
  count: any;
  formGroup: any;
  dialogRef: any;
  http: any;

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private modalCtrl: ModalController,
    //private router: Router,
    private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.onLoad();

    this.filterForm = new FormGroup({
      schemeFilter: new FormControl(null, [Validators.required]),
      lotteryFilter: new FormControl(null, [Validators.required]),
      stageNumberFilter: new FormControl(null, [Validators.required]),
      stageStatusFilter: new FormControl(null, [Validators.required]),
    });
  }

  onLoad() {

    const schemeFilter = this.filterForm.value.schemeFilter;
    this.masterService.getSubmittedInvoiceData(this.currentPage,this.pageSize,this.stageValue, schemeFilter).subscribe((data) => {
      console.log(data);
      this.isLoading = false;
      this.page=data;
      this.dataSource = new MatTableDataSource(this.page.content);
      console.log("dataSource >>>> ",this.dataSource);
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = this.page.totalElements;
      });
    },
    (error) => {
      console.log(error);
      this.isLoading = false;
      // this.isSearchDisabled = false;
  });
  }
  
  onSearch() {
    this.isLoading = true;
    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["schemeFilter"].setValue(null);
    this.stageValue = null;
    this.filterForm.controls["stageNumberFilter"].setValue(null);
    this.onLoad();
  }

  updateSubmitButtonStatus() {
    this.isSubmitDisabled = this.selectedElements.length === 0;
  }
  
  async openModal() {
    const modal = await this.modalCtrl.create({
            component: InvoiceModal,
            cssClass: "master-modal-lg",
            componentProps: {
              toApplicantData: this.selectedElements,
            },
          });
          await modal.present();
          this.isSubmitDisabled = false;
          const { data } = await modal.onWillDismiss();

          if (data === "submit") {
            this.isLoadingAfterSave = true;
            this.onLoad()
            
          }
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }
  
  deleteInvoice(key: number){
    if(confirm("Do you want to delete record?")) {
     this.masterService.deleteInvoiceRecord(key).subscribe((data:any)=>{
       if(data.status === 'SUCCESS') {
         this.masterService.successToast("Invoice record has been deleted successfully.");
         this.onLoad();
       }
       else {
         this.masterService.errorToast(data.errorMessage);
       }
     });
    }

 }
 
 onChangeForStage(value: any, name: any) {
  console.log("name+++++++++", name)
  this.stageValue = value;
  this.stageName = name;
  this.currentPage = 0;
  this.onLoad();
}

 getStageName(value: any): string {
  const stage = this.stageList.find(stage => stage.value === value);
  return stage ? stage.name : '';
}


  showStatusClass(status: string) {
    let statusClass = 'text-white p-1 pl-2 pr-2 text-sm border-round';
    if(status === 'Verified' || status === 'Answered') {
      return statusClass + ' bg-green-400';
    }
    else if(status === 'Not Applicable') {
      return statusClass + ' surface-700';
    }
    else if(status?.indexOf('Pending') >= 0) {
      return statusClass + ' bg-orange-400';
    }
    else {
      return statusClass + ' bg-orange-400';
    }
  }

  showObj(o1: any, o2: any) {    
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

async errorToast(errorMessage: string, dur?: number) {
  await this._snackBar.open(errorMessage, "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "error-toast",
    duration: dur ? dur : 3 * 1000,
  });
}
async successToast() {
  await this._snackBar.open("Invoice Details saved successfully.", "Close", {
    horizontalPosition: "right",
    verticalPosition: "top",
    panelClass: "success-toast",
    duration: 3 * 1000,
  });
}

}
